(function () {
  function initStickyHeader() {
    var headers = Array.prototype.slice.call(document.querySelectorAll('.foria-site-header'));

    if (!headers.length) {
      return;
    }

    var firstContent = document.querySelector(
      '#MainContent > .shopify-section:first-child, #MainContent > section:first-child, #MainContent > div:first-child'
    );
    var firstSurface =
      firstContent &&
      (firstContent.matches(
        '.foria-home__hero, .foria-template-hero, .foria-product-detail, .foria-page__contact-hero, .foria-page__contact, .foria-page__dark-band'
      )
        ? firstContent
        : firstContent.querySelector(
            '.foria-home__hero, .foria-template-hero, .foria-product-detail, .foria-page__contact-hero, .foria-page__contact, .foria-page__dark-band'
          ));
    var startsOverDark = !!(
      firstSurface &&
      firstSurface.matches('.foria-home__hero, .foria-template-hero--dark, .foria-page__contact-hero, .foria-page__dark-band')
    );
    var ticking = false;

    function update() {
      var isScrolled = window.scrollY > 12;

      headers.forEach(function (header) {
        header.classList.toggle('is-over-dark', startsOverDark);
        header.classList.toggle('is-scrolled', isScrolled);
      });

      document.documentElement.classList.toggle('foria-header-scrolled', isScrolled);
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyHeader);
  } else {
    initStickyHeader();
  }

  if (!window.gsap) {
    return;
  }

  var gsap = window.gsap;
  var ScrollTrigger = window.ScrollTrigger;
  var Observer = window.Observer;
  var Lenis = window.Lenis;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smoothScroll;
  var pageTransitionsReady = false;
  var pageTransitioning = false;

  if (ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  if (Observer) {
    gsap.registerPlugin(Observer);
  }

  function debounce(callback, wait) {
    var timeout;

    return function () {
      window.clearTimeout(timeout);
      timeout = window.setTimeout(callback, wait);
    };
  }

  function initSmoothScrolling() {
    if (smoothScroll || reduceMotion || !Lenis || (window.Shopify && window.Shopify.designMode)) {
      return;
    }

    smoothScroll = new Lenis({
      duration: 1.05,
      lerp: 0.085,
      smoothWheel: true,
      smoothTouch: false,
      wheelMultiplier: 0.9,
    });


    gsap.ticker.add(function (time) {
      smoothScroll.raf(time * 1000);
    });

    gsap.ticker.lagSmoothing(0);
    window.ForiaSmoothScroll = smoothScroll;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href^="#"]');
      var hash = link ? link.getAttribute('href') : '';

      if (!link || hash === '#') {
        return;
      }

      var target = document.querySelector(hash);
      if (!target) {
        return;
      }

      event.preventDefault();
      smoothScroll.scrollTo(target, { offset: -90 });
    });
  }

  function getStoredTransitionFlag() {
    try {
      return window.sessionStorage.getItem('foriaPageTransition');
    } catch (error) {
      return null;
    }
  }

  function setStoredTransitionFlag(value) {
    try {
      if (value) {
        window.sessionStorage.setItem('foriaPageTransition', value);
      } else {
        window.sessionStorage.removeItem('foriaPageTransition');
      }
    } catch (error) {
      return;
    }
  }

  function getPageTransitionOverlay() {
    var overlay = document.querySelector('.foria-page-transition');

    if (overlay) {
      return overlay;
    }

    overlay = document.createElement('div');
    overlay.className = 'foria-page-transition';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    return overlay;
  }

  function shouldUsePageTransition(event, link) {
    if (
      reduceMotion ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
      pageTransitioning ||
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      (window.Shopify && window.Shopify.designMode)
    ) {
      return false;
    }

    if (!link || link.target || link.hasAttribute('download') || link.closest('[data-no-page-transition]')) {
      return false;
    }

    var rawHref = link.getAttribute('href');

    if (!rawHref || rawHref.charAt(0) === '#' || /^(mailto|tel|sms|javascript):/i.test(rawHref)) {
      return false;
    }

    var url;

    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) {
      return false;
    }

    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) {
      return false;
    }

    return true;
  }

  function playPageEnterTransition() {
    if (reduceMotion || getStoredTransitionFlag() !== '1') {
      setStoredTransitionFlag('');
      var staleOverlay = getPageTransitionOverlay();

      if (staleOverlay) {
        staleOverlay.classList.remove('is-entering', 'is-leaving');
        gsap.set(staleOverlay, { autoAlpha: 0, yPercent: 104 });
      }

      return;
    }

    setStoredTransitionFlag('');

    var overlay = getPageTransitionOverlay();
    overlay.classList.remove('is-leaving');
    overlay.classList.add('is-entering');
    gsap.set(overlay, { autoAlpha: 1, yPercent: 0 });
    gsap.to(overlay, {
      yPercent: -108,
      duration: 1.02,
      ease: 'power3.inOut',
      delay: 0.06,
      onComplete: function () {
        overlay.classList.remove('is-entering');
        gsap.set(overlay, { autoAlpha: 0, yPercent: 104 });
        pageTransitioning = false;

        if (smoothScroll) {
          smoothScroll.start();
        }
      },
    });
  }

  function initPageTransitions() {
    if (pageTransitionsReady || reduceMotion) {
      return;
    }

    pageTransitionsReady = true;
    getPageTransitionOverlay();
    playPageEnterTransition();

    window.addEventListener('pageshow', function () {
      pageTransitioning = false;

      if (getStoredTransitionFlag() === '1') {
        playPageEnterTransition();
        return;
      }

      var overlay = document.querySelector('.foria-page-transition');

      if (overlay) {
        overlay.classList.remove('is-entering', 'is-leaving');
        gsap.set(overlay, { autoAlpha: 0, yPercent: 104 });
      }

      if (smoothScroll) {
        smoothScroll.start();
      }
    });

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');

      if (!shouldUsePageTransition(event, link)) {
        return;
      }

      event.preventDefault();
      pageTransitioning = true;

      var overlay = getPageTransitionOverlay();
      var destination = link.href;

      setStoredTransitionFlag('1');
      overlay.classList.remove('is-entering');
      overlay.classList.add('is-leaving');

      if (smoothScroll) {
        smoothScroll.stop();
      }

      gsap.set(overlay, { autoAlpha: 1, yPercent: 104 });
      gsap.to(overlay, {
        yPercent: 0,
        duration: 0.88,
        ease: 'power3.inOut',
        onComplete: function () {
          window.setTimeout(function () {
            window.location.href = destination;
          }, 80);
        },
      });
    });
  }

  function initDirectionalMarquees(root) {
    var marquees = Array.prototype.slice.call(root.querySelectorAll('[data-foria-marquee]'));

    marquees.forEach(function (marquee) {
      if (marquee.dataset.foriaMarqueeReady === 'true') {
        return;
      }

      var rail = marquee.querySelector('.foria-home__marquee-rail');
      if (!rail) {
        return;
      }

      marquee.dataset.foriaMarqueeReady = 'true';
      var baseHtml = rail.innerHTML;
      var tween;
      var observer;
      var directionTween;
      var currentDirection = 1;

      function build() {
        if (tween) {
          tween.kill();
        }

        if (observer) {
          observer.kill();
        }

        if (directionTween) {
          directionTween.kill();
        }

        currentDirection = 1;

        rail.innerHTML = '';

        var group = document.createElement('div');
        group.className = 'foria-home__marquee-group';
        group.innerHTML = baseHtml;
        rail.appendChild(group);

        while (group.scrollWidth < marquee.offsetWidth * 1.25) {
          group.insertAdjacentHTML('beforeend', baseHtml);
        }

        var clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        rail.appendChild(clone);

        if (reduceMotion) {
          return;
        }

        var distance = group.getBoundingClientRect().width;
        var speed = Math.max(18, distance / 85);

        tween = gsap.fromTo(
          rail,
          { x: 0 },
          {
            x: -distance,
            duration: speed,
            ease: 'none',
            repeat: -1,
            onReverseComplete: function () {
              this.totalTime(this.rawTime() + this.duration() * 100);
            },
          }
        );

        if (Observer) {
          observer = Observer.create({
            target: window,
            type: 'wheel,touch',
            onChangeY: function (self) {
              if (!self.deltaY) {
                return;
              }

              var direction = self.deltaY < 0 ? -1 : 1;
              var delta = Math.abs(self.deltaY);
              var burst = direction * gsap.utils.clamp(1.4, 2.75, 1.35 + delta / 260);

              if (directionTween) {
                directionTween.kill();
              }

              if (direction !== currentDirection) {
                currentDirection = direction;
                tween.timeScale(direction * gsap.utils.clamp(1.1, 2.2, Math.abs(tween.timeScale())));
              }

              directionTween = gsap
                .timeline({ defaults: { overwrite: true } })
                .to(tween, { timeScale: burst, duration: 0.1, ease: 'power2.out' })
                .to(tween, { timeScale: direction, duration: 0.34, ease: 'sine.out' }, '>-0.01');
            },
          });
        }
      }

      build();

      window.addEventListener(
        'resize',
        debounce(function () {
          build();
        }, 180)
      );
    });
  }

  function prepareTextMask(element) {
    if (element.dataset.foriaTextReady === 'true') {
      return Array.prototype.slice.call(element.querySelectorAll('.foria-text-mask-line > *'));
    }

    element.dataset.foriaTextReady = 'true';

    var directChildren = Array.prototype.slice.call(element.children);
    var directSpans = directChildren.filter(function (child) {
      return child.tagName === 'SPAN';
    });

    if (directSpans.length && directSpans.length === directChildren.length) {
      directSpans.forEach(function (span) {
        var line = document.createElement('span');
        line.className = 'foria-text-mask-line';
        span.parentNode.insertBefore(line, span);
        line.appendChild(span);
      });
    } else {
      var content = element.innerHTML.trim();
      element.innerHTML = '<span class="foria-text-mask-line"><span>' + content + '</span></span>';
    }

    return Array.prototype.slice.call(element.querySelectorAll('.foria-text-mask-line > *'));
  }

  function initTextMasks(root) {
    if (reduceMotion || !ScrollTrigger) {
      return;
    }

    var targets = Array.prototype.slice.call(
      root.querySelectorAll(
        '.foria-home__display, .foria-home__heading, .foria-page__display, .foria-page__story h2, .foria-page__dark-band h2'
      )
    ).filter(function (target) {
      return target.dataset.foriaScrollSplitReady !== 'true';
    });

    targets.forEach(function (target) {
      var lines = prepareTextMask(target);

      gsap.set(lines, { yPercent: 112, rotate: 1.5 });
      gsap.to(lines, {
        yPercent: 0,
        rotate: 0,
        duration: 1.15,
        ease: 'power4.out',
        stagger: 0.08,
        scrollTrigger: {
          trigger: target,
          start: 'top 86%',
          once: true,
        },
      });
    });
  }

  function getLineKey(element) {
    return Math.round(element.offsetTop);
  }

  function splitElementIntoLines(element, originalText) {
    element.innerHTML = '';
    element.classList.add('foria-scroll-split');
    element.setAttribute('aria-label', originalText);

    originalText.split(' ').forEach(function (word, index) {
      var wordElement = document.createElement('span');
      wordElement.className = 'foria-scroll-split-word';
      wordElement.textContent = word;
      element.appendChild(wordElement);

      if (index < originalText.split(' ').length - 1) {
        element.appendChild(document.createTextNode(' '));
      }
    });

    var measuredWords = Array.prototype.slice.call(element.querySelectorAll('.foria-scroll-split-word'));
    var lines = [];
    var currentLine = [];
    var currentKey;

    measuredWords.forEach(function (word) {
      var key = getLineKey(word);

      if (currentKey === undefined) {
        currentKey = key;
      }

      if (key !== currentKey) {
        lines.push(currentLine);
        currentLine = [];
        currentKey = key;
      }

      currentLine.push(word.textContent);
    });

    if (currentLine.length) {
      lines.push(currentLine);
    }

    element.innerHTML = '';

    lines.forEach(function (lineWords) {
      var line = document.createElement('span');
      var inner = document.createElement('span');

      line.className = 'foria-scroll-split-line';
      inner.className = 'foria-scroll-split-line-inner';
      line.setAttribute('aria-hidden', 'true');
      inner.textContent = lineWords.join(' ');

      line.appendChild(inner);
      element.appendChild(line);
    });

    return Array.prototype.slice.call(element.querySelectorAll('.foria-scroll-split-line-inner'));
  }

  function initScrollTextSplits(root) {
    if (reduceMotion || !ScrollTrigger) {
      return;
    }

    var targets = Array.prototype.slice.call(
      root.querySelectorAll(
        '.foria-home__heading, .foria-home__pillar h3, .foria-home__product h3, .foria-shop__meta h2, .foria-template-cta h2, .foria-page__story h2, .foria-page__dark-band h2'
      )
    ).filter(function (target) {
      return (
        target.children.length === 0 &&
        target.textContent.trim().split(/\s+/).length > 2 &&
        target.dataset.foriaTextReady !== 'true'
      );
    });

    targets.forEach(function (target) {
      if (target.dataset.foriaScrollSplitReady === 'true') {
        return;
      }

      target.dataset.foriaScrollSplitReady = 'true';

      var originalText = target.textContent.trim().replace(/\s+/g, ' ');
      var tween;

      function build() {
        if (tween) {
          tween.scrollTrigger.kill();
          tween.kill();
        }

        var lines = splitElementIntoLines(target, originalText);
        gsap.set(lines, { yPercent: 120 });

        tween = gsap.to(lines, {
          yPercent: 0,
          ease: 'none',
          stagger: 0.08,
          scrollTrigger: {
            trigger: target,
            scrub: true,
            start: 'clamp(top 88%)',
            end: 'clamp(bottom 52%)',
          },
        });
      }

      build();

      if (document.fonts) {
        document.fonts.ready.then(function () {
          build();
          ScrollTrigger.refresh();
        });
      }

      window.addEventListener(
        'resize',
        debounce(function () {
          build();
          ScrollTrigger.refresh();
        }, 220)
      );
    });
  }

  function initTextEntries(root) {
    if (reduceMotion || !ScrollTrigger) {
      return;
    }

    var targets = Array.prototype.slice.call(
      root.querySelectorAll(
        '.foria-eyebrow, .foria-home__lead, .foria-home__actions, .foria-home__stats div, .foria-home__intro > p, .foria-home__pillar p:last-child, .foria-home__selection-head .foria-home__text-link, .foria-home__product-link > p, .foria-home__product-head, .foria-home__house-copy p:not(.foria-eyebrow), .foria-home__house-copy .foria-home__text-link, .foria-home__visit-inner p:not(.foria-eyebrow), .foria-template-hero__split p, .foria-page__intro, .foria-page__contact-block p, .foria-template-cta p:not(.foria-eyebrow)'
      )
    ).filter(function (target) {
      return !target.closest('[data-foria-marquee]') && target.dataset.foriaScrollSplitReady !== 'true';
    });

    gsap.set(targets, { autoAlpha: 0, y: 28 });

    ScrollTrigger.batch(targets, {
      start: 'top 88%',
      once: true,
      onEnter: function (batch) {
        gsap.to(batch, {
          autoAlpha: 1,
          y: 0,
          duration: 0.9,
          ease: 'power3.out',
          stagger: 0.06,
          overwrite: true,
        });
      },
    });
  }

  function initImageReveals(root) {
    if (reduceMotion || !ScrollTrigger) {
      return;
    }

    var medias = Array.prototype.slice.call(
      root.querySelectorAll(
        '.foria-home__product-media, .foria-home__house-photo, .foria-shop__media, .foria-product-detail__media, .foria-page__media'
      )
    );

    medias.forEach(function (media) {
      if (media.dataset.foriaImageReady === 'true') {
        return;
      }

      media.dataset.foriaImageReady = 'true';
      media.classList.add('foria-image-reveal');

      if (media.querySelector('img')) {
        media.classList.add('foria-image-reveal--has-img');
      }

      gsap.set(media, {
        '--foria-image-mask-bottom': '100%',
        '--foria-image-y': '2.2rem',
        '--foria-image-scale': 1.075,
        '--foria-image-jelly-x': 1,
        '--foria-image-jelly-y': 1,
      });

      var timeline = gsap.timeline({
        scrollTrigger: {
          trigger: media,
          start: 'top 88%',
          end: 'top 42%',
          scrub: 0.8,
        },
      });

      timeline
        .to(
          media,
          {
            '--foria-image-mask-bottom': '0%',
            '--foria-image-y': '0rem',
            '--foria-image-scale': 1.018,
            duration: 1,
            ease: 'none',
          },
          0
        )
        .to(media, { '--foria-image-jelly-x': 1.012, '--foria-image-jelly-y': 0.99, duration: 0.18, ease: 'none' }, 0.08)
        .to(media, { '--foria-image-jelly-x': 0.996, '--foria-image-jelly-y': 1.006, duration: 0.22, ease: 'none' }, 0.28)
        .to(media, { '--foria-image-jelly-x': 1, '--foria-image-jelly-y': 1, duration: 0.28, ease: 'none' }, 0.54);
    });
  }

  function ensureGooeyLiquidFilter() {
    var filter = document.getElementById('foria-gooey-liquid');

    if (filter) {
      return filter;
    }

    var svgNamespace = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNamespace, 'svg');
    var defs = document.createElementNS(svgNamespace, 'defs');
    var blur = document.createElementNS(svgNamespace, 'feGaussianBlur');
    var matrix = document.createElementNS(svgNamespace, 'feColorMatrix');
    var blend = document.createElementNS(svgNamespace, 'feBlend');

    svg.classList.add('foria-svg-filter-defs');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('width', '0');
    svg.setAttribute('height', '0');

    filter = document.createElementNS(svgNamespace, 'filter');
    filter.setAttribute('id', 'foria-gooey-liquid');
    filter.setAttribute('x', '-35%');
    filter.setAttribute('y', '-35%');
    filter.setAttribute('width', '170%');
    filter.setAttribute('height', '170%');
    filter.setAttribute('color-interpolation-filters', 'sRGB');

    blur.setAttribute('in', 'SourceGraphic');
    blur.setAttribute('stdDeviation', '8');
    blur.setAttribute('result', 'blur');

    matrix.setAttribute('in', 'blur');
    matrix.setAttribute('mode', 'matrix');
    matrix.setAttribute(
      'values',
      '1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 24 -10'
    );
    matrix.setAttribute('result', 'goo');

    blend.setAttribute('in', 'SourceGraphic');
    blend.setAttribute('in2', 'goo');

    filter.appendChild(blur);
    filter.appendChild(matrix);
    filter.appendChild(blend);
    defs.appendChild(filter);
    svg.appendChild(defs);
    document.body.appendChild(svg);

    return filter;
  }

  function createButtonLiquid(button) {
    var liquid = document.createElement('span');
    var body = document.createElement('span');
    var bubblePositions = [16, 27, 39, 48, 58, 69, 80, 88];

    liquid.className = 'foria-button-liquid';
    liquid.setAttribute('aria-hidden', 'true');
    body.className = 'foria-button-liquid__body';
    liquid.appendChild(body);

    bubblePositions.forEach(function (position, index) {
      var bubble = document.createElement('span');
      var drift = index % 2 === 0 ? -0.36 - index * 0.03 : 0.34 + index * 0.03;

      bubble.className = 'foria-button-liquid__foam-bubble';
      bubble.style.setProperty('--foria-foam-x', position + '%');
      bubble.style.setProperty('--foria-foam-size', (0.24 + (index % 3) * 0.08).toFixed(2) + 'rem');
      bubble.style.setProperty('--foria-foam-delay', (-index * 0.18).toFixed(2) + 's');
      bubble.style.setProperty('--foria-foam-drift', drift.toFixed(2) + 'rem');
      liquid.appendChild(bubble);
    });

    button.insertBefore(liquid, button.firstChild);

    return liquid;
  }

  function initButtonLiquids(root) {
    if (reduceMotion) {
      return;
    }

    ensureGooeyLiquidFilter();

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.foria-home__button'));

    buttons.forEach(function (button) {
      if (button.dataset.foriaLiquidReady === 'true') {
        return;
      }

      if (button.disabled || button.getAttribute('aria-disabled') === 'true') {
        return;
      }

      button.dataset.foriaLiquidReady = 'true';
      createButtonLiquid(button);

      var lastX = 50;
      var lastTime = performance.now();

      function moveLiquid(event) {
        var rect = button.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        var now = performance.now();
        var delta = Math.max(16, now - lastTime);
        var velocity = (x - lastX) / delta;
        var tilt = Math.max(-9, Math.min(9, velocity * 190));
        var level = Math.max(-13, Math.min(-4, -12 + y * 0.08));
        var wave = Math.max(-0.45, Math.min(0.45, (50 - y) / 85));

        lastX = x;
        lastTime = now;

        gsap.to(button, {
          '--foria-liquid-x': x + '%',
          '--foria-liquid-level': level + '%',
          '--foria-liquid-tilt': tilt + 'deg',
          '--foria-liquid-wave': wave + 'rem',
          duration: 0.42,
          ease: 'elastic.out(1, 0.55)',
          overwrite: true,
        });
      }

      function enter(event) {
        lastX = 50;
        lastTime = performance.now();
        moveLiquid(event);
      }

      function leave() {
        gsap.to(button, {
          '--foria-liquid-x': '50%',
          '--foria-liquid-level': '118%',
          '--foria-liquid-tilt': '0deg',
          '--foria-liquid-wave': '0rem',
          duration: 0.72,
          ease: 'elastic.out(1, 0.5)',
          overwrite: true,
        });
      }

      button.addEventListener('pointerenter', enter);
      button.addEventListener('pointermove', moveLiquid);
      button.addEventListener('pointerleave', leave);
      button.addEventListener('focus', function () {
        gsap.to(button, {
          '--foria-liquid-level': '-8%',
          '--foria-liquid-tilt': '-2deg',
          duration: 0.58,
          ease: 'elastic.out(1, 0.55)',
          overwrite: true,
        });
      });
      button.addEventListener('blur', leave);
    });
  }

  function createGooeyLayer(target, blobCount) {
    var layer = document.createElement('span');

    layer.className = 'foria-gooey-liquid';
    layer.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < blobCount; index += 1) {
      var blob = document.createElement('span');
      var size = 1.1 + index * 0.28;

      blob.className = 'foria-gooey-liquid__blob';
      blob.style.setProperty('--foria-gooey-size', size.toFixed(2) + 'rem');
      layer.appendChild(blob);
    }

    target.insertBefore(layer, target.firstChild);

    return layer;
  }

  function isPointerFine() {
    return window.matchMedia('(pointer: fine)').matches;
  }

  function initGooeyLiquidSurfaces(root) {
    if (reduceMotion || !isPointerFine()) {
      return;
    }

    ensureGooeyLiquidFilter();

    var selectors = [
      '.foria-home__product',
      '.foria-shop__card',
      '.foria-page__steps article',
      '.foria-product-detail__specs article',
    ].join(', ');
    var targets = Array.prototype.slice.call(root.querySelectorAll(selectors));

    targets.forEach(function (target) {
      if (
        target.dataset.foriaGooeyReady === 'true' ||
        target.disabled ||
        target.getAttribute('aria-disabled') === 'true'
      ) {
        return;
      }

      target.dataset.foriaGooeyReady = 'true';
      target.classList.add('foria-gooey-surface');

      var isCard = target.matches(
        '.foria-home__product, .foria-shop__card, .foria-page__steps article, .foria-product-detail__specs article'
      );
      var disableCardTilt = target.matches('.foria-home__product, .foria-shop__card');
      var layer = createGooeyLayer(target, isCard ? 5 : 4);
      var blobs = Array.prototype.slice.call(layer.querySelectorAll('.foria-gooey-liquid__blob'));
      var lastX = 50;
      var lastTime = performance.now();

      if (isCard) {
        target.classList.add('foria-gooey-card');
        if (disableCardTilt) {
          target.classList.add('foria-gooey-card--static');
        }
      } else {
        target.classList.add('foria-gooey-link');
      }

      gsap.set(layer, { autoAlpha: 0 });
      gsap.set(blobs, { scale: 0.15, opacity: 0 });

      function move(event) {
        var rect = target.getBoundingClientRect();
        var x = ((event.clientX - rect.left) / rect.width) * 100;
        var y = ((event.clientY - rect.top) / rect.height) * 100;
        var now = performance.now();
        var delta = Math.max(16, now - lastTime);
        var velocity = (x - lastX) / delta;
        var squeeze = Math.max(0.82, Math.min(1.28, 1 + Math.abs(velocity) * 14));

        lastX = x;
        lastTime = now;

        blobs.forEach(function (blob, index) {
          var lag = index * 0.035;
          var driftX = (index - 2) * 5 + velocity * (index + 1) * 180;
          var driftY = Math.sin((x + index * 26) * 0.045) * 7 + (index % 2 === 0 ? -3 : 4);

          gsap.to(blob, {
            left: x + '%',
            top: y + '%',
            x: driftX,
            y: driftY,
            scaleX: squeeze + index * 0.04,
            scaleY: 1 / squeeze,
            duration: 0.42 + lag,
            ease: 'elastic.out(1, 0.64)',
            overwrite: true,
          });
        });

        if (isCard && !disableCardTilt) {
          var tiltX = ((50 - y) / 50) * 2.4;
          var tiltY = ((x - 50) / 50) * 3.2;

          gsap.to(target, {
            '--foria-card-tilt-x': tiltX.toFixed(2) + 'deg',
            '--foria-card-tilt-y': tiltY.toFixed(2) + 'deg',
            '--foria-card-lift': '-0.42rem',
            duration: 0.5,
            ease: 'power3.out',
            overwrite: true,
          });
        }
      }

      function enter(event) {
        target.classList.add('is-gooey-active');
        lastX = 50;
        lastTime = performance.now();

        gsap.to(layer, { autoAlpha: 1, duration: 0.18, ease: 'power2.out', overwrite: true });
        gsap.to(blobs, {
          opacity: function (index) {
            return index === 0 ? 0.9 : 0.62;
          },
          scale: function (index) {
            return index === 0 ? 1.18 : 0.72 + index * 0.12;
          },
          duration: 0.36,
          ease: 'back.out(1.8)',
          stagger: 0.035,
          overwrite: true,
        });

        move(event);
      }

      function leave() {
        target.classList.remove('is-gooey-active');

        gsap.to(layer, { autoAlpha: 0, duration: 0.32, ease: 'power2.out', overwrite: true });
        gsap.to(blobs, {
          scale: 0.18,
          opacity: 0,
          x: 0,
          y: 0,
          duration: 0.34,
          ease: 'power3.out',
          overwrite: true,
        });

        if (isCard && !disableCardTilt) {
          gsap.to(target, {
            '--foria-card-tilt-x': '0deg',
            '--foria-card-tilt-y': '0deg',
            '--foria-card-lift': '0rem',
            duration: 0.58,
            ease: 'elastic.out(1, 0.7)',
            overwrite: true,
          });
        }
      }

      target.addEventListener('pointerenter', enter);
      target.addEventListener('pointermove', move);
      target.addEventListener('pointerleave', leave);
      target.addEventListener('focus', function () {
        target.classList.add('is-gooey-active');
        gsap.to(layer, { autoAlpha: 1, duration: 0.2, ease: 'power2.out', overwrite: true });
        gsap.to(blobs, {
          left: '50%',
          top: '50%',
          opacity: function (index) {
            return index === 0 ? 0.82 : 0.54;
          },
          scale: function (index) {
            return index === 0 ? 1 : 0.64 + index * 0.1;
          },
          duration: 0.34,
          ease: 'back.out(1.7)',
          stagger: 0.035,
          overwrite: true,
        });
      });
      target.addEventListener('blur', leave);
    });
  }

  function init(root) {
    var scope = root || document;

    initSmoothScrolling();
    initPageTransitions();
    initDirectionalMarquees(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
